import { customization } from '@yola/ws-sdk';
import extractScriptsFromTemplate from './extract-scripts-from-template';
import compileCustomTemplate from './compile-custom-template';
import constants from '../constants';

const { SCRIPT_REGEXP } = constants;

const setCurrentFont = (global, font, customTemplate, selector) => {
  const node = global.cloneNode(true);

  const compiledCustomTemplate = compileCustomTemplate(customTemplate, font);

  const el = node.querySelector(selector);

  if (compiledCustomTemplate.match(SCRIPT_REGEXP)) {
    const { scripts, template } = extractScriptsFromTemplate(compiledCustomTemplate);

    el.innerHTML = template;

    el.append(...scripts);
  } else {
    el.innerHTML = compiledCustomTemplate;
  }

  el.setAttribute(customization.constants.FONTS_DATA_ATTRIBUTE, font.id);

  if (font.parentId) {
    el.setAttribute(customization.constants.PARENT_FONTS_DATA_ATTRIBUTE, font.parentId);
  } else if (el.hasAttribute(customization.constants.PARENT_FONTS_DATA_ATTRIBUTE)) {
    el.removeAttribute(customization.constants.PARENT_FONTS_DATA_ATTRIBUTE);
  }

  return node;
};

export default setCurrentFont;
